module.exports = __webpack_public_path__ + "static/moba-coin-a154d21dad3fc381cff8cffd8cac4e6c.jpg";